module.exports = __webpack_public_path__ + "static/media/skating.0d545ef7.png";